import { Button } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
// import CreateEditBusinessUnitModal from "./createEditBusinessUnit";
import {
  actionsColumn,
  hideColumn,
  textColumn
} from "../../components/tableComponent/columns";
import TableComponent from "../../components/tableComponent";
// import "./styles.css";
import {
  CreateUpdateApiKey,
  callApiAsync,
  GetApiKeyList,
  RegenerateApiKey
} from "../../services/apiService";
import AlertComponent from "../../components/alertModal";
import ToastNotification from "../../components/toastNotification";
import ButtonComponent from "../../components/button";
import icons from "../../constants/icons";
import StatusPill from "../../components/statusPill";
import CreateupdateUserApiModal from "./CreateUpdateApiKey";
const UserApi = () => {
  const [UserApiKeys, setUserApiKeys] = useState([]);
  const [openCreateEdit, setOpenCreateEdit] = useState(false);

  const [selectedRow, setSelectedRow] = useState({});

  const [alertOpen, setAlertOpen] = useState(false);

  const [toastMessage, setToastMessage] = useState("");
  const [toastOpen, setToastOpen] = useState(false);
  const [toastSeverity, setToastSeverity] = useState("warning");

  const getUserApiTable = () => {
    callApiAsync(GetApiKeyList, (data) => {
      setUserApiKeys(data);
    });
  };

  useEffect(() => {
    getUserApiTable();
  }, []);

 const createApiKey = (formData) => {
    callApiAsync(
      () => CreateUpdateApiKey(formData),
      (data) => {
        if(data){
          setToastMessage(data);
          setToastOpen(true);
        }
      getUserApiTable();
        
      }
    );
  };

  const handleCreateEdit = (row) => {
    if (!row) {
      setSelectedRow({});
      setOpenCreateEdit(true);
      return;
    }
    setSelectedRow(row);
    setOpenCreateEdit(true);
  };

  const handleClose = () => {
    setOpenCreateEdit(false);
  };

  const handleCopy = (row) => {
    const apiKey = row.apiKey;
    navigator.clipboard.writeText(apiKey)
      .then(() => {
        console.log("Copiado al portapapeles:", apiKey);
      })
      .catch(err => {
        console.error("Error al copiar:", err);
      });
  };
  const handleRegenerate = (row) => {
    callApiAsync(
      () => RegenerateApiKey(row),
      (data) => {
        if(data){
          setToastMessage(data);
          setToastOpen(true);
        }
        getUserApiTable();
        
      }
    );
  };

  const actionBtn = ({ row }) => (
    <div className="HContainer">
      <ButtonComponent
        onClick={() => handleCreateEdit(row.original)}
        variant="contained"
        backgroundColor="#fff0"
      >
        <img className="btn-icon" src={icons.blue_edit} alt="icon" />
      </ButtonComponent>
      <ButtonComponent
        onClick={() => handleCopy(row.original)}
        variant="contained"
        backgroundColor="#fff0"
      >
        <img className="btn-icon" src={icons.copy} alt="copy icon" />
      </ButtonComponent>
      <ButtonComponent
        onClick={() => handleRegenerate(row.original)}
        variant="contained"
        backgroundColor="#fff0"
      >
        <img className="btn-icon" src={icons.key} alt="copy icon" />
      </ButtonComponent>
    </div>
  );
  
  const formatDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (isNaN(date)) return value;
    return date.toLocaleDateString("es-CO"); // dd/mm/aaaa en español
  };

  const columns = useMemo(
    () => [
      // hideColumn("id", "id"),
      // hideColumn("userId", "id de usuario "),
      textColumn("email", "Correo", 300),
      textColumn("enterpriseKey", "Unidad de negocio"),
      {
        accessorKey: "apiKey",
        header: "Clave",
        // size: 300,
        Cell: ({ row }) => {
          const value = row.original.apiKey || "";

          if (value.length <= 8) return value; // seguridad

          const visibleStart = value.substring(0, 4);
          const visibleEnd = value.substring(value.length - 4);

          const masked = `${visibleStart}********${visibleEnd}`;

          return masked;
        }
      },
      // hideColumn("modificationDate", "Fecha modificacion"),
      textColumn("creationDate", "Fecha creación", undefined, {
        Cell: ({ row }) => formatDate(row.original.creationDate)
      }),
      textColumn("expiredDate", "Fecha expiración", undefined, {
        Cell: ({ row }) => formatDate(row.original.expiredDate)
      }),
      actionsColumn(actionBtn)
    ],
    []
  );

  return (
    <div>
      <h1>Api Keys</h1>
      <div>
        <TableComponent
          columns={columns}
          data={UserApiKeys}
          enableGlobalFilter={true}
          initialState={{
            sorting: [
              {
                id: "enterpriseKey",
                desc: false
              }
            ]
          }}
          headerButtons={() =>
            <>
              <ButtonComponent
                onClick={() => handleCreateEdit()}
                type="submit"
                variant="contained"
                backgroundColor="#F6C079"
                textColor="#000000"
                margin="15px 0"
              >
                <div className="HContainer a-center">
                  <img
                    className="btn-icon icon-margin-r-15"
                    src={icons.plus}
                    alt="icon"
                  />
                  <p>Crear Clave de API</p>
                </div>
              </ButtonComponent>
            </>
          }
        />
      </div>
      <CreateupdateUserApiModal 
        open={openCreateEdit} 
        onClose={handleClose} 
        rowData={selectedRow}
        onSubmitFuntion={createApiKey}/>
      <ToastNotification
        open={toastOpen}
        handleClose={() => setToastOpen(false)}
        message={toastMessage}
        severity={toastSeverity}
      />
    </div>
  );
};

export default UserApi;
